import React from 'react';
import cl from './UserInfoForm.module.css';
import {user} from "../../modules/User";

const UserInfoForm = () => {
    return (
        <div className={cl.main} style={{visibility: Boolean(user.id) ? "visible" : "hidden"}}>
            <div className={cl.row}>
                <h2>Добро пожаловать, <span className={cl.hlText}>{user.name}</span>!</h2>
            </div>
            <div style={{color: "#aaaaaa"}}>
                <p>e-mail: {user.email}</p>
                <p>uid: {user.id}</p>
            </div>
            <hr style={{border: "1px solid #606060", margin: "10px 0px"}}/>
            <div className={cl.row} style={{marginBottom: "10px"}}>
                <h3>Внесено событий: <span className={cl.hlText}>{user.addedEventCount}</span></h3>
            </div>
            {/*<div className={cl.row} style={{marginBottom: "10px"}}>
                <h3>Внесено: {user.userAdded} из {user.totalAdded} событий</h3>
            </div>
            {
                user.logs.map(
                    (log) => <div key={`${log.date_time}${log.details}`} className={cl.row}>
                                <p>{log.date_time}: {log.action} - {log.details}</p>
                            </div>
                )
            }*/}
        </div>
    );
};

export default UserInfoForm;